import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ProplayFetcher } from "./ProplayFetcher";
import { ProplaySynergy } from "./ProplaySynergy";
import "./index.css";


export function App() {
  return (
    <div className="text-center relative z-10 w-full max-w-full">
      <div className="grid gap-6 max-w-6xl mx-auto text-left">
        <Card>
          <CardHeader className="gap-3">
            <CardTitle className="text-2xl font-bold">Proplay Fetcher</CardTitle>
            <CardDescription>
              Pull the latest 1000 games from gol.gg and save them to data/proplay-games.json
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ProplayFetcher />
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="gap-3">
            <CardTitle className="text-2xl font-bold">Proplay Synergy</CardTitle>
            <CardDescription>
              Pick champions by role to see which teammates show up most often in other roles.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ProplaySynergy />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default App;
